import { Helmet } from 'react-helmet-async';

var seoData = {
  home: {
    title: "Elektriker Wuppertal | FESCH Elektrotechnik GmbH - Ihr Fachbetrieb",
    description: "FESCH Elektrotechnik GmbH - Ihr zertifizierter Elektriker in Wuppertal. Elektroinstallation, Photovoltaik, Brandmeldeanlagen & Sicherheitstechnik. Kostenlose Beratung! DIN ISO 9001 zertifiziert.",
    keywords: "Elektriker Wuppertal, Elektrotechnik Wuppertal, Elektroinstallation, Photovoltaik Wuppertal, Brandmeldeanlage, Sicherheitsbeleuchtung, Sprachalarmierung, Sprachalarmanlage, Elektriker NRW",
    canonical: "https://www.fesch-elektrotechnik.de/"
  },
  referenzen: {
    title: "Referenzen | Elektrotechnik Projekte in NRW & Deutschland | FESCH",
    description: "Entdecken Sie unsere erfolgreich abgeschlossenen Elektrotechnik-Projekte in Wuppertal, Köln, Bremen und ganz Deutschland. Elektroinstallation, Brandmeldeanlagen & mehr.",
    keywords: "Elektrotechnik Referenzen, Projekte Elektriker, Intimissimi Elektroinstallation, Brandmeldeanlage Projekte, Sicherheitsbeleuchtung Referenzen",
    canonical: "https://www.fesch-elektrotechnik.de/referenzen/wuppertal"
  },
  karriere: {
    title: "Karriere bei FESCH | Elektriker Jobs in Wuppertal | Jetzt bewerben",
    description: "Starte deine Karriere bei FESCH Elektrotechnik in Wuppertal. Wir suchen Elektriker, Elektroniker und Auszubildende. Attraktive Benefits und spannende Projekte.",
    keywords: "Elektriker Jobs Wuppertal, Elektroniker Stellenangebot, Ausbildung Elektriker NRW, Elektrotechnik Karriere",
    canonical: "https://www.fesch-elektrotechnik.de/karriere"
  },
  impressum: {
    title: "Impressum | FESCH Elektrotechnik GmbH Wuppertal",
    description: "Impressum und rechtliche Informationen der FESCH Elektrotechnik GmbH, Wuppertal.",
    keywords: "",
    canonical: "https://www.fesch-elektrotechnik.de/impressum"
  },
  datenschutz: {
    title: "Datenschutzerklärung | FESCH Elektrotechnik GmbH Wuppertal",
    description: "Datenschutzerklärung der FESCH Elektrotechnik GmbH. Informationen zur Verarbeitung Ihrer personenbezogenen Daten.",
    keywords: "",
    canonical: "https://www.fesch-elektrotechnik.de/datenschutzerklarung/"
  },
  kontakt: {
    title: "Kontakt | FESCH Elektrotechnik GmbH Wuppertal | Jetzt anfragen",
    description: "Kontaktieren Sie FESCH Elektrotechnik in Wuppertal. Kostenlose Beratung für Elektroinstallation, Photovoltaik und Sicherheitstechnik. Schnelle Rückmeldung garantiert!",
    keywords: "Kontakt Elektriker Wuppertal, Elektrotechnik Anfrage, Kostenlose Beratung Elektriker",
    canonical: "https://www.fesch-elektrotechnik.de/kontakt/"
  },
  dienstleistungen: {
    title: "Dienstleistungen | Elektroinstallation & Photovoltaik | FESCH Wuppertal",
    description: "Unsere Leistungen: Elektroinstallation, Photovoltaik, Brandmeldeanlagen, Sicherheitsbeleuchtung, Smart Home und mehr. FESCH Elektrotechnik Wuppertal.",
    keywords: "Elektroinstallation Wuppertal, Photovoltaik Installation, Brandmeldeanlage, Sicherheitsbeleuchtung, Smart Home Elektriker",
    canonical: "https://www.fesch-elektrotechnik.de/dienstleistungen/"
  }
};

export function SEO({ page }) {
  var data = seoData[page] || seoData.home;
  
  return (
    <Helmet>
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      {data.keywords ? <meta name="keywords" content={data.keywords} /> : null}
      <link rel="canonical" href={data.canonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta property="og:url" content={data.canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:site_name" content="FESCH Elektrotechnik GmbH" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={data.title} />
      <meta name="twitter:description" content={data.description} />
    </Helmet>
  );
}

export default SEO;
